
import { ref, computed } from "vue";
import { useStore } from 'vuex';
import { Helper } from "@/utils/Helper";
import { NotificationUtils } from "@/utils/NotificationUtils";
import qrcode from "qrcode-generator";
import { Peer } from "peerjs";
import layoutHomeAutoSignQRModal from "@/layouts/home/components/modals/layoutHomeAutoSignQRModal.vue";
import { Notification } from '@/_models/Notification';
import { TransactionMapping, SignedTransaction } from "tsjs-xpx-chain-sdk";

export default{
  name: 'notificationsDisplayAllComponent',
  components: {
    layoutHomeAutoSignQRModal
  },
  setup(){
    const store = useStore();
    const noti = new NotificationUtils();
    // const fetchedNotification = ref([]);
    const displayedNotification = ref([]);
    const qr = ref('');
    const title = ref('');
    const message = ref('');

    let txn = TransactionMapping.createFromPayload('C2010000777C9A1A2F15721297A7B3ABF237ADFD80951752FDF10547C1790B9F7D43005F1870FE08927073A4CE294971D2E81A5F6622B34817E92C7E13A5F692C8ACCB099CAF24BD6C46CD8FD5AC7F5117C3E564C6EAF09335EECFE6A15DA9F958307A8A020000A841413006510000000000E9AB351131000000E4000000720000009CAF24BD6C46CD8FD5AC7F5117C3E564C6EAF09335EECFE6A15DA9F958307A8A030000A85441A8955DBCB3905AC7796F05A90B65B0634A4CB1EE650E2EDDD71C000100436C61696D696E67203620323338464644463031383336333037437C303618F0FD8F23060000000000000072000000D2D7B6B27923FEDC667DBB075C6E1385E90291C0A0E9A52A9C4D2F23F4FFE20C030000A85441A8FC2C2516EBFB2C1DD32430E5F94F8E74D5051DF446C048D81C000100436C61696D696E6720362032333846464446303138333633303743F6BD1691A142FBBFE03D2A03000000009CAF24BD6C46CD8FD5AC7F5117C3E564C6EAF09335EECFE6A15DA9F958307A8AC49134E1D30E41774ED8E1418F391CC3E0803D19D983B5726B04300F1A439A341E1FCD03C487733C2613BE1C9D65CA176CD82BF6D875E0289752F21B0505780A')
    let txn2 = SignedTransaction.createFromPayload('C2010000777C9A1A2F15721297A7B3ABF237ADFD80951752FDF10547C1790B9F7D43005F1870FE08927073A4CE294971D2E81A5F6622B34817E92C7E13A5F692C8ACCB099CAF24BD6C46CD8FD5AC7F5117C3E564C6EAF09335EECFE6A15DA9F958307A8A020000A841413006510000000000E9AB351131000000E4000000720000009CAF24BD6C46CD8FD5AC7F5117C3E564C6EAF09335EECFE6A15DA9F958307A8A030000A85441A8955DBCB3905AC7796F05A90B65B0634A4CB1EE650E2EDDD71C000100436C61696D696E67203620323338464644463031383336333037437C303618F0FD8F23060000000000000072000000D2D7B6B27923FEDC667DBB075C6E1385E90291C0A0E9A52A9C4D2F23F4FFE20C030000A85441A8FC2C2516EBFB2C1DD32430E5F94F8E74D5051DF446C048D81C000100436C61696D696E6720362032333846464446303138333633303743F6BD1691A142FBBFE03D2A03000000009CAF24BD6C46CD8FD5AC7F5117C3E564C6EAF09335EECFE6A15DA9F958307A8AC49134E1D30E41774ED8E1418F391CC3E0803D19D983B5726B04300F1A439A341E1FCD03C487733C2613BE1C9D65CA176CD82BF6D875E0289752F21B0505780A', store.getters['config/generationHash'])
    console.log(txn);
    console.log(txn2);

    const isPeerConnectionMade = ref(false);
    const istxnSigned = ref(false);
    const isDisabledModalConfirmSubmitButton = ref(true);

    const isQRModalOpened = ref(false);
    const closeModal = () => {
      isQRModalOpened.value = false;
    }
    const displayQRModal = async(ttl: string, msg: string, payload: string, notificationId: string) => {
      isQRModalOpened.value = true;
      title.value = ttl;
      message.value = msg;

      const peer = new Peer();
      const secret = "this is a secret";
      const qrCode = qrcode(0, 'H');
      peer.on("open", (id) => {
        let data = {
          // payload: payload,
          payload: id,
          type:'reqPeerID',
          recvId: id,
          secret: secret,
          generationHash: store.getters['config/generationHash'],
          chain: 'off',
          callbackUrl: null
        }
        qrCode.addData(JSON.stringify(data));
        qrCode.make();
        qr.value = qrCode.createSvgTag({scalable: true});
        // console.log(payload)
        // console.log(qr.value)
        let txn = TransactionMapping.createFromPayload(payload);
        console.log(txn)
      });

      peer.on("connection", (conn) => {
        conn.on("data", async(data: any) => {
          if(data === 'requestTxnSigning'){
            isPeerConnectionMade.value = true;
            conn.send({
              type: 'txn',
              payload: payload
            });
          }else if(data === 'txnHash'){
            conn.send("success");
            isPeerConnectionMade.value = false;
            istxnSigned.value = true;
            isDisabledModalConfirmSubmitButton.value = false;
          }else{
            await noti.fetchReadNotification('notificationId=' + notificationId);
          }
        });
      });
    }

    // pagination
    const totalAssets = ref(0);
    const pages = ref(20);
    const currentPage = ref(1);
    const totalPages = ref(0);
    const enableNextPage = ref(false);

    // pagination
    let fetchedNotification;
    const loadNotifications = async() => {
      fetchedNotification = await noti.fetchAllNotifications(currentPage.value-1, Number(pages.value) + 1);
      if(fetchedNotification.length > pages.value){
        enableNextPage.value = true;
        displayedNotification.value = fetchedNotification.splice(0, pages.value);
      }else{
        enableNextPage.value = false;
        displayedNotification.value = fetchedNotification;
      }
    };
    loadNotifications();

    const enableFirstPage = computed(()=> {
      return currentPage.value > 1;
    });

    const enablePreviousPage = computed(() => {
      return currentPage.value > 1;
    });

    const naviFirst = () => {
      currentPage.value = 1;
      loadNotifications();
    };

    const naviPrevious =() => {
      --currentPage.value;
      loadNotifications();
    };

    const naviNext = () => {
      ++currentPage.value;
      loadNotifications();
    };

    const naviLast = () => {
      currentPage.value = totalPages.value;
      loadNotifications();
    };

    const changeRows = () => {
      loadNotifications();
    }

    return {
      qr,
      title,
      message,
      isQRModalOpened,
      closeModal,
      displayQRModal,
      displayedNotification,
      // pagination
      enableFirstPage,
      enablePreviousPage,
      enableNextPage,
      totalAssets,
      pages,
      currentPage,
      totalPages,
      naviFirst,
      naviPrevious,
      naviNext,
      naviLast,
      changeRows,
      Helper,
      isPeerConnectionMade,
      istxnSigned,
      isDisabledModalConfirmSubmitButton,
    }
  }
}
